import React from 'react'
import ReactDOM from 'react-dom/client'
import './config/amplify' // Initialize Amplify before anything else
import App from './App.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// PWA Service Worker — auto-update simplificado
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // Chequear actualizaciones al iniciar
        registration.update().catch(() => {})

        // Chequear cuando el usuario vuelve a la app
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => {})
          }
        })
      })
      .catch(() => {})
  })

  // Cuando el nuevo SW toma el control, mostrar banner y recargar
  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.dispatchEvent(new CustomEvent('pwa-updating'))
    setTimeout(() => window.location.reload(), 1200)
  })
}
